import MapControlLayer from "../MapControlLayer";

export default class ShapeLayer extends MapControlLayer {
  static NORMAL_STYLE_PROPERTIES = {
    strokeColor: "strokeColor",
    strokeWidth: "strokeWidth",
    fillColor: "fillColor",
    fillOpacity: "fillOpacity"
  }
  
  static STATUS_VISIBLE_STYLE_PROPERTIES = {
    strokeColor: "statusVisibleStrokeColor",
    strokeWidth: "statusVisibleStrokeWidth",
    fillColor: "statusVisibleFillColor",
    fillOpacity: "statusVisibleFillOpacity"
  }
  
  static SELECTED_STYLE_PROPERTIES = {
    strokeColor: "selectedStrokeColor",
    strokeWidth: "selectedStrokeWidth",
    fillColor: "selectedFillColor",
    fillOpacity: "selectedFillOpacity"
  }
  
  constructor(id, dataStream, selectionDataStream, propertiesDictionary, linkedHideable) {
    super(id, dataStream, selectionDataStream, linkedHideable);
    
    if (propertiesDictionary) {
      this.propertiesDictionary = propertiesDictionary;
    } else {
      this.propertiesDictionary = this.NORMAL_STYLE_PROPERTIES;
    }
  }
  
  getStrokeWidthExpression(scalable, projectionProxy) {
    var expression = null;
    
    if (scalable) {
      const zoomStops = [ 0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0 ];
      
      expression = ['interpolate', ['linear'], ['zoom']];
      
      for (var zoomStop of zoomStops) {
        const worldZoomStop = projectionProxy.toWorldZoom(zoomStop);
        const property = [ "get", this._zoomStopProperty(worldZoomStop, this.propertiesDictionary.strokeWidth) ];
        expression.push(worldZoomStop, property);
      }
    } else {
      const worldZoomStop = projectionProxy.toWorldZoom(0);
      expression = ["get", this._zoomStopProperty(worldZoomStop, this.propertiesDictionary.strokeWidth) ];
    }
    
    return expression
  }
  
  // getStrokePatternStrings(shapes) {
  // 	const strokePatterns = [];
  
  // 	for (var shape of shapes) {
  //         const normalStyle = shape.style;
  //         const selectedStyle = shape.selectedStyle;
  //         const statusVisibleStyle = shape.statusVisibleStyle;
  
  // 		NewMapControlStyle normalStyle = shape.getNormalStyle(normalStylePredicates, availableStyles);
  // 		if (normalStyle != null) {
  // 			double normalStrokeWidth = normalStyle.getStrokeWidth();
  // 			float[] normalStrokePattern = normalStyle.getStrokePattern();
  // 			if (normalStrokePattern != null) {
  // 				StringBuffer strokePatternString = new StringBuffer();
  // 				for (int i = 0 ; i < normalStrokePattern.length - 1; i ++) {
  // 					float part = normalStrokePattern[i] / (float) normalStrokeWidth;
  // 					strokePatternString.append(part).append("_");
  // 				}
  // 				float part = normalStrokePattern[normalStrokePattern.length - 1] / (float) normalStrokeWidth;
  // 				strokePatternString.append(part);
  
  // 				strokePatterns.add(strokePatternString.toString());
  // 			}
  // 		}
  
  // 		NewMapControlStyle selectedStyle = shape.getSelectedStyle(selectedStylePredicates, availableStyles);
  // 		if (selectedStyle != null) {
  // 			double selectedStrokeWidth = selectedStyle.getStrokeWidth();
  // 			float[] selectedStrokePattern = selectedStyle.getStrokePattern();
  // 			if (selectedStrokePattern != null) {
  // 				StringBuffer strokePatternString = new StringBuffer();
  // 				for (int i = 0 ; i < selectedStrokePattern.length - 1; i ++) {
  // 					float part = selectedStrokePattern[i] / (float) selectedStrokeWidth;
  // 					strokePatternString.append(part).append("_");
  // 				}
  // 				float part = selectedStrokePattern[selectedStrokePattern.length - 1] / (float) selectedStrokeWidth;
  // 				strokePatternString.append(part);
  
  // 				strokePatterns.add(strokePatternString.toString());
  // 			}
  // 		}
  
  // 		NewMapControlStyle statusStyle = shape.getStatusStyle(statusStylePredicates, availableStyles);
  // 		if (statusStyle != null) {
  // 			double statusVisibleStrokeWidth = statusStyle.getStrokeWidth();
  // 			float[] statusVisibleStrokePattern = statusStyle.getStrokePattern();
  // 			if (statusVisibleStrokePattern != null) {
  // 				StringBuffer strokePatternString = new StringBuffer();
  // 				for (int i = 0 ; i < statusVisibleStrokePattern.length - 1; i ++) {
  // 					float part = statusVisibleStrokePattern[i] / (float) statusVisibleStrokeWidth;
  // 					strokePatternString.append(part).append("_");
  // 				}
  // 				float part = statusVisibleStrokePattern[statusVisibleStrokePattern.length - 1] / (float) statusVisibleStrokeWidth;
  // 				strokePatternString.append(part);
  
  // 				strokePatterns.add(strokePatternString.toString());
  // 			}
  // 		}
  // 	}
  
  // 	return strokePatterns;
  // }
}
